export default __webpack_public_path__ + "static/media/sweets-23.8bf23be6.png";